var ListingLabel;
(function (ListingLabel) {
  ListingLabel["SALES"] = "sales";
  ListingLabel["RENTAL"] = "rental";
  ListingLabel["SHARE"] = "share";
})(ListingLabel || (ListingLabel = {}));
export default ListingLabel;